const temas_sin_combinar = ['fauna','vegetacion','edafologia','poblacion','mineria','usosuelo','propiedadesSuelo'],
    fichaDefault = "areas";

export default {
    namespaced: true,
    state: () => ({
        temasExpandidos:{
            "hidrografia":true,
            "areas":true,
            "fauna":false,
            "vegetacion":false,
            "edafologia":false,
            "poblacion":false,
            "mineria":false,
            "usosuelo":false,
            "propiedadesSuelo":false
        },
        
        capasAreasActivas:[
            'areas_region_nororiental',
            'areas_subcuenca',
            'areas_zona_federal_lago_texcoco',
            'areas_obra_principal_naim',
            'areas_zona_pelt',
        ],
        
        faunaVerMalla:true,
        faunaTiposActivos:['aves'],
        poblacionNivelSeleccionado:'localidad', // 'localidad' | 'municipio'
        propiedadSueloSeleccionado:'ph', // 'ph' | 'salinidad' | 'riesgo'
        fichaActiva:fichaDefault,
        leyendasBiofisicoActivasEnMobile:true,
        leyendasSocioterritorialActivasEnMobile:true,
        mapaEnMobile:true //por lo del first mobile
    }),
    mutations:{
        setTemasExpandidos(state,payload){
            //verificar que solo uno de los temas sin combinar este activo
            if(temas_sin_combinar.includes(payload.tema) && payload.expandido ){
                for(let tema of temas_sin_combinar){
                    if(tema !== payload.tema){
                        state.temasExpandidos[tema] = false
                    }
                }
            }

            state.temasExpandidos[payload.tema] = payload.expandido;

            // Cambia la ficha activa cuando se activa la capa
            state.fichaActiva = payload.expandido ? payload.tema: fichaDefault;
        },
        enciendeCapa(state,nombre){
            if(!state.capasAreasActivas.includes(nombre)){
                state.capasAreasActivas.push(nombre)
            }
        },
        apagaCapa(state,nombre){
            if(state.capasAreasActivas.includes(nombre)){
                state.capasAreasActivas.splice(state.capasAreasActivas.indexOf(nombre),1)
            }
        },
        setFaunaTipos(state,payload){
            const tipo = payload.tipo;
            const visible = payload.visible
            if(state.faunaTiposActivos.includes(tipo) && !visible){
                state.faunaTiposActivos.splice(state.faunaTiposActivos.indexOf(tipo),1)
            }else if(!state.faunaTiposActivos.includes(tipo) && visible){
                state.faunaTiposActivos.push(tipo)
            }
            
        },
        setFaunaVerMalla(state,visible){
            state.faunaVerMalla = visible
        },
        setPoblacionNivelSeleccionado(state,nivel){
            state.poblacionNivelSeleccionado = nivel;
            state.fichaActiva = nivel === 'localidad' ? 'poblacion': 'poblacion_municipios'
        },
        setPropiedadSueloSeleccionado(state,propiedad){
            state.propiedadSueloSeleccionado = propiedad;
        },
        setFichaActiva(state, nombre) {
            state.fichaActiva = nombre;
        },
        setLeyendasBiofisicoActivasEnMobile(state,activo){
            state.leyendasBiofisicoActivasEnMobile = activo
        },
        setLeyendasSocioterritorialActivasEnMobile(state,activo){
            state.leyendasSocioterritorialActivasEnMobile = activo
        },
        setMapaEnMobile(state,is_mobile){
            state.mapaEnMobile = is_mobile
        }
    },
    getters:{
        estaCapaActiva(state){
            return (nombre)=>{
                return state.capasAreasActivas.includes(nombre)
            }
        },
        esteTipoDeFaunaEstaActivo(state){
            return (tipo)=>{
                return state.faunaTiposActivos.includes(tipo)
            }
        }
    }
}